import {
  getGetFrontRichiesteIdProcuratoreQueryKey,
  useDeleteFrontRichiesteIdProcuratore,
} from '@framework/api-client';
import { useMemo } from 'react';
import { queryClient } from '../../../../core/network/queryClient';

/**
 * Hook che ritorna la funzione per rimuovere il gestore di una richiesta.
 */
export function useRemoveSubmissionManager() {
  const removeAttorney = useDeleteFrontRichiesteIdProcuratore();

  const remove = useMemo(
    () => ({
      mutateAsync: async (submissionId: string) => {
        await removeAttorney.mutateAsync({
          id: submissionId,
        });
        await queryClient.invalidateQueries(
          getGetFrontRichiesteIdProcuratoreQueryKey(submissionId),
        );
      },
    }),
    [removeAttorney],
  );

  return { remove };
}
